import type { FC } from 'react';
import { useAppSelector } from 'store/hooks';
import { isDisplayPageSelector } from 'store/slices/deposit';
import {
  displaySelectListOptionsSelector,
  isStatusPageModeSelector,
  selectedPayGroupIdSelector,
} from 'store/slices/global';
import { notificationsSelector } from 'store/slices/notifications';

import { NotificationItem } from './NotificationItem';
import styles from './Notifications.module.scss';

export const NotificationsController: FC = () => {
  const payGroupId = useAppSelector(selectedPayGroupIdSelector);
  const isStatusPage = useAppSelector(isStatusPageModeSelector);
  const notifications = useAppSelector(notificationsSelector(payGroupId));
  const displaySelectListOptions = useAppSelector(displaySelectListOptionsSelector);
  const isDisplayPage = useAppSelector(isDisplayPageSelector);

  if (!notifications.length || isStatusPage || !!displaySelectListOptions || isDisplayPage) {
    return null;
  }

  return (
    <section data-testid="notification-container" className={styles.items}>
      {notifications.map((notification) => (
        <NotificationItem key={notification.key} notification={notification} />
      ))}
    </section>
  );
};
